import React from 'react'
import PropTypes from 'prop-types'
import { mdiInformationOutline } from '@mdi/js'

import Text from '../../../../Components/Formik/Text'

const CoVSoundComponent = ({ translate, ...rest }) => (
  <>
    <Text
      name="reporting.value"
      label={translate('labels.covAcceptable')}
      accessoryText={`dB ${translate('labels.covLastKnown')}`}
      prefixText="+/-"
      textHelper={translate('labels.covSoundHelper')}
      hasTooltip
      tooltipIcon={mdiInformationOutline}
      tooltipContent={translate('labels.covRangeTooltip')}
      type="number"
      min="0"
      max="20"
      data-testid="cov-sound-input"
      {...rest}
    />
  </>
)

CoVSoundComponent.propTypes = {
  translate: PropTypes.func.isRequired
}

export default CoVSoundComponent
